import { render } from "./ChannelListModal.vue?vue&type=template&id=46032ad6&bindings={\"setChannelFunction\":\"props\",\"max_add_reach\":\"props\",\"close_modal\":\"props\",\"modal_title\":\"props\",\"input_name\":\"props\",\"channels\":\"props\",\"language\":\"setup\",\"lang\":\"data\"}"
import script from "./ChannelListModal.vue?vue&type=script&lang=js"
export * from "./ChannelListModal.vue?vue&type=script&lang=js"

import "./ChannelListModal.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script